import React, {useState, useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const SessionChartCpCurve = (props) => {

  const [loading, setLoading] = useState(false);
  const [chartOptions, setChartOptions] = useState();
  
  useEffect(() => {
    setLoading(true);
    updateOptions();
    setLoading(false);
  }, []);


  const handleZoom = (e, props) => {
    props.handleChangeZoom(e);
  }

  const handleToolTip = (point, props, e) => {
    props.handleChangeToolTip(point, e);
  }

  const updateOptions = async () => {

    // try {

      let plotSeries = [];
      let counter = 0;

      let chartTheme = {
        background: "#ffffff",
        color: "rgba(33,33,33,1)",
        seriesColors: ['#3f93f4', '#999999', '#ffa505'],
        gridColor: "#E6E6E6"
      };

      await Object.keys(props.data.cpResults).forEach(function(key) {
        plotSeries.push({
          x: counter,
          y: parseInt(props.data.cpResults[key].avg)
        });
        counter++;
      });

      let chartOptions = {
        chart: {
          type: 'pie',
          zoomType: '',
          animation: false,
          backgroundColor: chartTheme.background,
          plotBackgroundColor: null,
          
        },
        credits: {
          enabled: false
        },
        title: {
          text: null
        },
        yAxis: {
          gridLineColor: chartTheme.gridColor,
          title: "",
            labels: {
              align: 'left',
              x: 0,
              y: -2,
              style: {
                color: chartTheme.color,
              }
          }
        },
        xAxis: {
          gridLineColor: chartTheme.gridColor,
          categories: props.data.cpIntervals,
          style: {
            color: chartTheme.color,
          },
          labels: {
            formatter: function () {
              var label = this.axis.defaultLabelFormatter.call(this);
    
              if (label > 60) {
                return (label / 60) + ':00';
              }else{
                return label + 's'
              }

            }
          }
        },
        plotOptions: {
          pie: {
            dataLabels: {
                distance: '-30%',
                style: {
                  textOutline: 0,
                  color: '#ffffff'
                }
            },
            shadow: false,
            center: ['50%', '50%'],
            borderWidth: 0
          }
        },
        series: [{
          showInLegend: false,
          animation: false,
          data: [{
              name: 'Right Balance',
              y: (100 - props.data.headerData.balanceAvg),
              sliced: true,
              color: chartTheme.seriesColors[0]
          },{
            name: 'Left Balance',
            y: props.data.headerData.balanceAvg,
            sliced: true,
            color: chartTheme.seriesColors[1]
        }]
        }]
      };

      setChartOptions(chartOptions);

  };


    return loading ? (
      <div>Loading main chart...</div>
    ) : (
      <div>
        <div>
          <HighchartsReact highcharts={Highcharts} options={chartOptions} />
        </div>
      </div>
    );

}

export default SessionChartCpCurve;
